import AxiosInstance from '../../config/AxiosInstance';

const syncDataToRedis = async (companyId: any) => {
    try {
        const { data } = await AxiosInstance.post(`/api/v1/redis/refresh/${companyId}`);
        return { data };
    } catch (error) {
        throw error;
    }
}

export {
    syncDataToRedis
}